import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEventContext } from '../../../context/event/hooks/use-event-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Heading } from '../../../subcomponents/heading';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultEventNameProps, eventNamePropsValidator } from './types/props';
const b = bemClassBuilder('v-event-name');
export const EventName = observer(props => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { config } = props;
    const { event } = useEventContext();
    if (!event)
        return enableSkeletonLoadingIndicators ? _jsx(EventNameSkeleton, {}) : null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(Heading, Object.assign({ level: config.headingLevel, className: b.element('heading') }, { children: i18n.translatable(event.name) })) })));
});
EventName.displayName = 'EventName';
export const EventNameSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
EventNameSkeleton.displayName = 'EventNameSkeleton';
/**
 * The **Event Name** component renders an event's name.
 */
export const EventNameComponent = withComponentWrapper(EventName, defaultEventNameProps, eventNamePropsValidator);
